var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offers-view"},[_c('h1',[_vm._v(_vm._s(_vm.$t('routes.offers')))]),_vm._l((_vm.categories),function(ref){
var categoryName = ref.name;
var size = ref.size;
var categoryOffers = ref.offers;
return _c('div',{key:("category." + categoryName),staticClass:"category"},[_c('h2',[_vm._v(_vm._s(_vm.$t(("categories." + categoryName))))]),_c('div',{staticClass:"offer-row"},_vm._l((categoryOffers),function(ref){
var id = ref.id;
var offerName = ref.name;
var imageUrl = ref.imageUrl;
return _c('Offer',{key:("offer." + id),attrs:{"name":offerName,"imageUrl":imageUrl,"size":size}})}),1)])}),_c('div',{staticClass:"soon"},[_c('div',{staticClass:"soon-text"},[_vm._v(_vm._s(_vm.$t('soon')))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }